import { useEffect, useState } from 'react';

const useCountdownTimer = (targetDate: string | number | Date) => {
  const [timeRemaining, setTimeRemaining] = useState('00:00:00');

  useEffect(() => {
    // 서버사이드에서는 타이머를 시작하지 않음
    if (typeof window === 'undefined') {
      return;
    }

    const _vDate = new Date(targetDate).getTime();

    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;

    const showRemaining = () => {
      const now = new Date().getTime();
      const distDt = _vDate - now;

      if (distDt < 0) {
        clearInterval(timer);
        setTimeRemaining('00:00:00');
        return;
      }

      const hours = Math.floor((distDt % (_hour * 24)) / _hour);
      const minutes = Math.floor((distDt % _hour) / _minute);
      const seconds = Math.floor((distDt % _minute) / _second);

      const formattedHours = hours < 10 ? `0${hours}` : hours;
      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
      const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

      setTimeRemaining(`${formattedHours}:${formattedMinutes}:${formattedSeconds}`);
    };

    const timer = setInterval(showRemaining, 1000);
    showRemaining(); // 컴포넌트가 마운트될 때 즉시 업데이트

    return () => clearInterval(timer); // 컴포넌트 언마운트 시 타이머 정리
  }, [targetDate]);

  return timeRemaining;
};

export default useCountdownTimer;